import { render, staticRenderFns } from "./examQuestions.vue?vue&type=template&id=390fad90&scoped=true"
import script from "./examQuestions.vue?vue&type=script&lang=js"
export * from "./examQuestions.vue?vue&type=script&lang=js"
import style0 from "./examQuestions.vue?vue&type=style&index=0&id=390fad90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390fad90",
  null
  
)

export default component.exports